module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_hotspots_black.0d6824c3.png";